<template>
   <div class="layout">
      <div class="layout__header">
         <div class="layout__title">
            <h3>Cambio de vendedores</h3>
         </div>
      </div>
      <div class="row">
         <div class="col-xs-12">
            <div class="form-field select2">
               <div class="select2-field">
                  <v-select :options="vendedores" label="nombre_usuario" id="vendedor" placeholder="Seleccione..." v-model="selectedVendedor" @input="inputVendedor"></v-select>
               </div>
            </div>
         </div>
      </div>
      <div class="modal-buttons">
         <button @click="cambiar" class="btn-success"><i class="fa fa-save"></i><span>Cambiar</span></button>
         <button @click="$emit('cerrar')" class="btn-danger btn--text"><i class="fa fa-times"></i><span>Cerrar</span></button>
      </div>
   </div>
</template>

<script>
export default {
   props : {
      vendedorId : {
         required : false,
         default : ''
      },
      comprobanteId : {
         type : String,
         required : false,
         default : ''
      },
      vendedores : {
         type : Array,
         required : false,
         default : function () {
            return [];
         }
      }
   },
   methods : {
      cambiar : function () {
         let that = this;
         if (this.form.vendedor_id == this.vendedorId) {
            swal('El vendedor a cambiar no debe ser el mismo.', 'Aviso', 'warning');
            return;
         }
         axios.post(url + '/comprobantes/' + this.comprobanteId + '/cambiar-vendedor', this.form).then(function () {
            swal('El vendedor ha sido cambiado.', 'Realizado', 'success');
            that.$emit('vendedorCambiado');
         }).catch(function () {
            swal('Hubo un error, intente nuevamente.', 'Aviso', 'warning');
         });
      },
      inputVendedor : function () {
         if (this.selectedVendedor !== null)
            this.form.vendedor_id = this.selectedVendedor.id;
         else 
            this.form.vendedor_id = '';
      }
   },
   data : function () {
      return {
         selectedVendedor : null,
         form : {
            vendedor_id : ''
         }
      };
   },
   mounted : function () {
      for (let i = 0; i < this.vendedores.length; i++) 
         if (this.vendedorId == this.vendedores[i].id) {
            this.selectedVendedor = this.vendedores[i];
            this.inputVendedor();
            break;
         }
   }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/cierre-comisiones/CambiarVendedor.vue